export enum UserRoleEnum {
  user = 'user',
  manager = 'manager',
  superAdmin = 'superAdmin',
}
